import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=b8835be8&"
import script from "./CustomerInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8835be8')) {
      api.createRecord('b8835be8', component.options)
    } else {
      api.reload('b8835be8', component.options)
    }
    module.hot.accept("./CustomerInfo.vue?vue&type=template&id=b8835be8&", function () {
      api.rerender('b8835be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/partials/CustomerInfo.vue"
export default component.exports